import React from 'react';
import { Spinner } from 'react-bootstrap';
import Delayed from './Delayed';
import WindTurbineSpinner from './WindTurbineSpinner';

type LoadingWrapperProps = {
    className?: string,
    children: React.ReactNode,
    showLoading?: boolean,
    loadingMessage?: string,
    windSpinner?: boolean,
    windSpinnerScale?: number
};

const LoadingWrapper = ({className = 'pt-5 text-center', children, showLoading = false, loadingMessage = '', windSpinner = false, windSpinnerScale = 1}: LoadingWrapperProps) => (
    <div style={{ position: 'relative', minHeight: showLoading ? (windSpinner ? windSpinnerScale * 100 + 60 : 200) : undefined }}>
        {showLoading && (
            <Delayed waitBeforeShow={500}>
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        zIndex: 10,
                        backgroundColor: 'rgba(255,255,255,0.75)',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    {windSpinner ? <WindTurbineSpinner scale={windSpinnerScale} /> : <Spinner animation="border" role="status" variant="primary"/>}
                    <p style={{ marginTop: 15 }}>{loadingMessage}</p>
                </div>
            </Delayed>
        )}
        <div>
            {children}
        </div>
    </div>
)

export default LoadingWrapper;